import { Award, GraduationCap, ShieldCheck, Heart } from "lucide-react";

const FOUNDER_IMG =
  "https://customer-assets.emergentagent.com/job_rhg-captivate/artifacts/itt86hvp_5FB1C028-5B15-414A-91B4-E56C6D0AD520.png";

const accolades = [
  {
    icon: GraduationCap,
    title: "EMBA · Georgetown",
    sub: "McDonough School of Business",
  },
  {
    icon: Award,
    title: "Top 40 Under 40 · 2018",
    sub: "Avenue Magazine & Forbes Feature",
  },
  {
    icon: ShieldCheck,
    title: "Certified Scrum Master",
    sub: "OSHA 510 · ServSafe Instructor",
  },
  {
    icon: Heart,
    title: "Philanthropic Leadership",
    sub: "Toyota Lexus Minority Dealers Assoc.",
  },
];

export const Founder = () => {
  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="relative py-28 md:py-40 bg-[#050914] overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full bg-[#d4af37]/5 blur-[120px]"
      />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        {/* Portrait */}
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <div className="relative reveal" data-testid="founder-image-wrap">
            <div className="absolute -bottom-5 -right-5 w-full h-full border border-[#d4af37] pointer-events-none" />
            <img
              src={FOUNDER_IMG}
              alt="Michael Briggs Jr., Founder of Richmond Holdings Group"
              className="relative w-full h-[520px] md:h-[640px] object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#050914] to-transparent" />
          </div>
          <div className="mt-6 reveal">
            <p className="text-[10px] uppercase tracking-[0.3em] text-slate-500">
              Founder &amp; Principal
            </p>
            <p className="font-serif-editorial text-2xl text-white mt-2">
              Michael Briggs Jr.
            </p>
          </div>
        </div>

        {/* Editorial copy */}
        <div className="lg:col-span-7">
          <p
            className="text-[11px] font-bold uppercase tracking-[0.32em] text-[#d4af37] mb-6 reveal"
            data-testid="founder-overline"
          >
            <span className="gold-rule" /> Founder Profile
          </p>
          <h2
            className="font-serif-editorial text-4xl md:text-5xl lg:text-[64px] font-light leading-[1.02] text-white reveal"
            data-testid="founder-headline"
          >
            Built to lead.
            <br />
            <span className="italic text-[#d4af37]">Driven to elevate.</span>
          </h2>

          <blockquote
            className="mt-10 border-l-2 border-[#d4af37] pl-6 md:pl-8 reveal"
            data-testid="founder-quote"
          >
            <p className="font-serif-editorial italic text-2xl md:text-3xl lg:text-4xl leading-[1.25] text-slate-100">
              “Leadership isn&apos;t just about strategy — it&apos;s about elevating the
              community and executing with absolute precision.”
            </p>
            <footer className="mt-5 text-[11px] uppercase tracking-[0.28em] text-slate-500">
              — Michael Briggs Jr., Founder
            </footer>
          </blockquote>

          <div className="mt-10 space-y-5 text-slate-400 leading-relaxed max-w-2xl reveal">
            <p>
              Michael Briggs Jr. is an accomplished business professional whose career
              spans federal contracting, executive advisory, and community impact.
              After earning his Executive MBA from Georgetown University&apos;s
              McDonough School of Business, he founded Richmond Holdings Group to
              bring enterprise rigor to government and commercial clients alike.
            </p>
            <p>
              A Certified Scrum Master, OSHA 510 credentialed, and ServSafe-approved
              instructor, Michael blends operational discipline with a philanthropic
              lens—serving as a member of the Toyota Lexus Minority Dealers Owners
              Association and its next generation of owners.
            </p>
            <p>
              In 2018 he was recognized among Avenue Magazine&apos;s Top 40 Under 40
              and profiled in Forbes as a leader redefining what excellence looks like
              for minority-owned consultancies.
            </p>
          </div>

          {/* Accolades grid */}
          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/10 reveal">
            {accolades.map((a) => {
              const Icon = a.icon;
              return (
                <div
                  key={a.title}
                  data-testid={`accolade-${a.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="bg-[#0a1324] p-6 md:p-7 flex items-start gap-4"
                >
                  <Icon
                    size={26}
                    strokeWidth={1.2}
                    className="text-[#d4af37] shrink-0 mt-1"
                  />
                  <div>
                    <p className="font-serif-editorial text-lg text-white leading-tight">
                      {a.title}
                    </p>
                    <p className="text-xs text-slate-500 mt-1">{a.sub}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
